import { todoCardIds } from '../../../../pages/home-page/version2/todo-cards/todo-card-ids';
import { CountryConfigNames } from '../../country-config-enums';
import { CountryUIFeature } from '../country-ui-feature';

export const NZCountryUIConfig = [
  new CountryUIFeature(CountryConfigNames.FTUWizardHiddenTodoCards, {
    todoCardIds: [todoCardIds.GET_STARTED_WEBINAR, todoCardIds.ACCOUNT_OPTIMIZATION_WEBINAR],
  }),
];
